import type { ReactNode } from 'react';

import { MAX_EDITORS_CHOICE_HEADLINE_LENGTH } from '../../../constants/form';
import { EditorsChoiceTooltip } from '../../EditorsChoiceTooltip';
import * as Form from '../../Form';
import { CharacterCountHint } from '../../shared/CharacterCountHint';
import { SectionHeader } from '../../shared/SectionHeader';
import type { DappFormInputChangeEvent } from '../types';

interface EditorsChoiceSectionBaseProps {
  headline: string;
  onInputChange: (event: DappFormInputChangeEvent) => void;
  graphicField: ReactNode;
}

export function EditorsChoiceSectionBase({
  headline,
  onInputChange,
  graphicField,
}: EditorsChoiceSectionBaseProps) {
  return (
    <section className="self-stretch flex flex-col gap-6">
      <SectionHeader
        title="Editor's Choice"
        description="The dApp Store home screen includes a featured carousel showcasing dApps that editors periodically select to highlight"
      >
        <EditorsChoiceTooltip>
          <button
            type="button"
            className="text-teal-500 text-sm hover:text-teal-400 mt-1 inline-block cursor-pointer"
          >
            See Editor&apos;s Choice placement details
          </button>
        </EditorsChoiceTooltip>
      </SectionHeader>

      <div className="self-stretch flex flex-col gap-1">
        <Form.Input
          label="Headline"
          explanation="To promote your dApp beyond the description"
          name="editorsChoiceHeadline"
          value={headline}
          onChange={onInputChange}
          maxLength={MAX_EDITORS_CHOICE_HEADLINE_LENGTH}
          placeholder="Enter headline"
        />
        <CharacterCountHint
          text={`${headline.length} / ${MAX_EDITORS_CHOICE_HEADLINE_LENGTH} characters`}
        />
      </div>

      <div className="self-stretch flex flex-col gap-2">{graphicField}</div>
    </section>
  );
}
